import clsx from 'clsx';
import type { LinksFunction } from '@remix-run/node';
import type { FC } from 'react';

import {
  LEGAL_URL,
  PRIVACY_POLICY_URL,
  YOUR_PRIVACY_CHOICES_URL,
} from '@/constants/urls';

import {
  SharedAnchor,
  links as sharedAnchorLinks,
} from '@/components/shared/shared-anchor/shared-anchor';

import iconYourPrivacyChoicesDark from '@/img/icon-your-privacy-choices-dark.svg?url';
import iconYourPrivacyChoicesLight from '@/img/icon-your-privacy-choices-light.svg?url';

import type { SharedSimpleFooterProps } from './shared-simple-footer.types';

import styles from './shared-simple-footer.css?url';

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: styles },
  ...sharedAnchorLinks(),
];

export const SharedSimpleFooter: FC<SharedSimpleFooterProps> = ({
  theme = 'dark',
  alignment = 'left',
  transparent,
}) => {
  const classes = clsx('shared-simple-footer', {
    'shared-simple-footer--dark': theme === 'dark',
    'shared-simple-footer--light': theme === 'light',
    'shared-simple-footer--center': alignment === 'center',
    'shared-simple-footer--transparent': transparent,
  });
  const anchorIntent = theme === 'dark' ? 'tertiary' : 'primary';

  return (
    <div className={classes}>
      <p className="shared-simple-footer__rights">
        © Aura {new Date().getFullYear()}. All rights reserved.
      </p>
      <div className="shared-simple-footer__navigation">
        <SharedAnchor href={LEGAL_URL} intent={anchorIntent} isNewTab>
          Legal
        </SharedAnchor>
        <SharedAnchor href={PRIVACY_POLICY_URL} intent={anchorIntent} isNewTab>
          Privacy Policy
        </SharedAnchor>
        <SharedAnchor
          href={YOUR_PRIVACY_CHOICES_URL}
          intent={anchorIntent}
          isNewTab
        >
          Your Privacy Choices
          <img
            src={
              theme === 'dark'
                ? iconYourPrivacyChoicesDark
                : iconYourPrivacyChoicesLight
            }
            alt=""
          />
        </SharedAnchor>
      </div>
    </div>
  );
};
